import { useRef, useState, useEffect } from 'react'
import styles from './subnavigation.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Link from './basic/link'

const navData = document.getElementById('nav-data') ? JSON.parse(document.getElementById('nav-data').innerHTML.replace(/&#038;/g, '&')) : null

function Subnavigation(props) {
    const ref = useRef(null)
    const currentUrl = window.location.href
    const activeParents = navData ? navData.main_items.filter(item => item.active_parent === 1) : []
    let activeParent = null

    //if there are multiple active parents, find the one that is the parent of the current post
    if(activeParents.length > 1) {
        let currentPost = activeParents[0]?.children?.find(child => child.active === 1)
        let currentPostParent = currentPost.post_parent
        activeParent = activeParents.find(item => item.object_id === currentPostParent.toString())
    } else {
        activeParent = activeParents[0]
    }
    
    const activeChild = activeParent ? activeParent?.children?.find(child => child.active === 1) : null
    const activeGrandChild = activeChild ? activeChild?.children?.find(child => child.active === 1) : null
    let activeNav = activeGrandChild ? activeChild : activeParent
    const [active, setActive] = useState(false)

    if(activeGrandChild) {
        if(activeNav?.children?.findIndex(item => item.ID == activeChild.ID) == -1) {
            activeNav.children.unshift(activeChild)
        }
    }

    //react onclick method to toggle menu
    const toggleMenu = () => {
        setActive(!active)
    }

    const resizeMenu = () => {
        if(!ref.current){
            return false
        }

        if(document.documentElement.clientWidth < 768) {
            ref.current.style.height = active ? ref.current.scrollHeight + 'px' : '0px'
        } else {
            ref.current.style.height = 'auto'
        }
    }

    useEffect(() => {
        resizeMenu()
    }, [active])

    useEffect(() => {
        window.addEventListener('resize', resizeMenu)
        return () => window.removeEventListener('resize', resizeMenu)
    }, [])

    return <BlockWrapper {...props} className={classNames(styles.menu, active ? styles.active : '')}>
        <ScrollAnimation styles={styles}>
            <div className={styles.menu_toggle}
                onClick={toggleMenu}
            >
                {activeNav && activeNav.title}
            </div>
            <div ref={ref} className={styles.menu_wrapper}>
                {activeNav?.children && activeNav.children
                    .filter(item => {
                        return !item.fields?.hide_on_subnav
                    }) // Filter out items with hide_on_subnav set to true
                    .map((item, i) => {
                        return <Link key={i} {...item} className={classNames(styles.link, currentUrl == item.url ? styles.active : '')}>
                            {item.title}{(item.fields?.subnavigation_label || item.fields?.additional_text) && 
                                <span className={styles.additional_text}> | {item.fields?.subnavigation_label ? item.fields?.subnavigation_label : item.fields?.additional_text}</span>
                            }
                        </Link>
                    })
                }
            </div>
        </ScrollAnimation>
    </BlockWrapper>
}

export default Subnavigation